export enum ModalType {
  DEFAULT = 'default',
  VIDEO = 'video',
}
